import { Table, TableWrapper, Tbody, Td, Tr } from '@components/core-ui/Table';
import { DisclosureSection } from '@components/core-ui/DisclosureSection';

import { routes } from '@routes';
import { AdminGetOrganizationResponseDto } from 'app/API';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CellContent } from './styles/CellContent';
import { Wrapper } from './styles/Wrapper';

type TProps = {
  repositories: AdminGetOrganizationResponseDto['repositories'];
};

export const RepositoriesTable = ({ repositories }: TProps) => {
  const [repositoriesDisclosureOpen, setRepositoriesDisclosureOpen] = useState<boolean>(true);
  const repositoriesSectionTitle = `Cases ${repositories?.length > 0 ? ` (${repositories?.length})` : ''}`;

  return (
    <Wrapper className="flex flex-col">
      <div>
        <DisclosureSection
          title={repositoriesSectionTitle}
          open={repositoriesDisclosureOpen}
          setOpenState={setRepositoriesDisclosureOpen}
          loading={false}
        >
          <TableWrapper>
            <Table>
              <Tbody>
                {(repositories ?? []).map((data) => (
                  <Tr key={data.id}>
                    <Td>
                      <Link to={routes.adminRepositoryDetails.make(data.id ?? '')} className="underline">
                        {data.name}
                      </Link>
                    </Td>
                    <Td>
                      <CellContent>
                        {data.jobsProcessing !== undefined ? (
                          <span style={{ display: 'block' }}>{data.jobsProcessing} jobs processing</span>
                        ) : null}
                      </CellContent>
                    </Td>
                    <Td>
                      <CellContent>
                        {data.jobsReadyForTranscribing !== undefined ? (
                          <span style={{ display: 'block' }}>
                            {data.jobsReadyForTranscribing} jobs ready for editing
                          </span>
                        ) : null}
                      </CellContent>
                    </Td>
                    <Td style={{ width: '1%' }}>
                      <CellContent>
                        {data.jobsComplete !== undefined ? (
                          <span style={{ display: 'block' }}>{data.jobsComplete} completed jobs</span>
                        ) : null}
                      </CellContent>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableWrapper>
        </DisclosureSection>
      </div>
    </Wrapper>
  );
};
